export const accordionSXProps = {
  backgroundColor: "#f6f6fe",
  boxShadow: "none",
  "&:before": { display: "none" },
  margin: "8px 0",
  "&:first-of-type": {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    "&.Mui-expanded": {
      marginTop: "8px",
    },
  },
  "&:last-of-type": {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  "&.Mui-expanded": {
    margin: "8px 0",
  },
};

export const summarySXProps = {
  flexDirection: "row-reverse",
  "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(90deg)",
    marginBottom: "4px",
  },
  padding: "0 32px",
  "&.MuiAccordionSummary-content": {
    margin: "10px 0",
  },
  "&.Mui-expanded .MuiAccordionSummary-content": {
    margin: "10px 0",
  },
  "&.Mui-expanded": {
    margin: "0",
    minHeight: 48,
  },
  minHeight: 48,
  "@media (max-width: 768px)": {
    padding: "0 16px",
  },
};

export const titleSXProps = {
  fontWeight: 600,
  fontFamily: "inherit",
  marginLeft: "16px",
  fontSize: 16,
  "@media (max-width: 768px)": {
    fontSize: 12,
    marginLeft: "10px",
  },
};

export const sharedAtSXProps = {
  fontFamily: "inherit",
  marginLeft: "auto",
  fontSize: 16,
  color: "#43444D",
  "@media (max-width: 768px)": {
    fontSize: 12,
  },
};
